import state from "./state";

export default {
      //例子
  get_name: (state) => {
      // console.log(state);
      return state;
  },
  getShopcarInfo(state) {
    return state.shopcarInfo;
  },
  needShowCartToSeconds(state) {
    return state.needShowCartToSeconds
  }
}


// WEBPACK FOOTER //
// ./src/store/getter.js